import { FunctionComponent, useState } from 'react';
import styles from './Sidebar.module.scss';
import AstronomicLogo from '../../../../../components/brand/AstronomicLogo/AstronomicLogo';
import classNames from 'classnames';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import MainButton from '../../../../../components/buttons/MainButton/MainButton';

type listItem = {
  title: string;
  icon: React.ReactElement;
  disabled?: boolean;
  completed?: boolean;
};

interface SidebarProps {
  list: listItem[];
  activeItem?: number;
  onItemClick?: (index: number, e?) => void;
}

const Sidebar: FunctionComponent<SidebarProps> = ({ list, activeItem = 0, onItemClick }) => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const [isOpenedOnMobile, setIsOpenedOnMobile] = useState(false);

  const renderList = () => {
    return (
      <ul className={styles['list']}>
        {list.map((item, i) => (
          <li
            className={classNames(
              styles['list__item'],
              activeItem === i && styles['list__item--active'],
              item?.disabled && styles['list__item--disabled'],
              item?.completed && styles['list__item--completed']
            )}
            key={i}
            onClick={(e) => {
              if (onItemClick) {
                onItemClick(i, e);
              }

              if (isOpenedOnMobile === true) {
                setIsOpenedOnMobile(false);
              }
            }}
          >
            <div className={styles['list__item__icon']}>{item.icon}</div>

            <p className={classNames(styles['list__item__title'], 'text text--caption text--bold')}>{item.title}</p>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className={classNames(styles['sidebar'], isOpenedOnMobile && styles['sidebar--is-mobile-opened'])}>
      <div className={classNames(styles['sidebar__content'], 'tile tile--padding-32px')}>
        <div className={styles['sidebar__content__header']}>
          <AstronomicLogo color="dark" />

          {isMobile ? (
            isOpenedOnMobile ? (
              renderList()
            ) : (
              <div className={styles['mobile-list']} onClick={() => setIsOpenedOnMobile(true)}>
                <div className={styles['mobile-list__top']}>
                  <ul className={styles['mobile-list__items']}>
                    {list.map((item, i) => (
                      <li
                        className={classNames(
                          styles['mobile-list__items__item'],
                          activeItem === i && styles['mobile-list__items__item--active']
                        )}
                        key={i}
                        onClick={(e) => {
                          if (onItemClick) {
                            onItemClick(i, e);
                          }
                        }}
                      >
                        <div className={styles['mobile-list__items__item__icon']}>{item.icon}</div>

                        <p
                          className={classNames(
                            styles['mobile-list__items__item__title'],
                            'text text--body-3 text--bold'
                          )}
                        >
                          {item.title}
                        </p>
                      </li>
                    ))}
                  </ul>

                  <div className={styles['mobile-list__arrow']}>
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="#5E617B">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7.70711 6.29289C8.09763 6.68342 8.09763 7.31658 7.70711 7.70711L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                      />
                    </svg>
                  </div>
                </div>

                <div className={styles['mobile-list__bottom']}>
                  <div className={styles['mobile-list__bullet-items']}>
                    {list.map((_, i) => (
                      <div
                        className={classNames(
                          styles['mobile-list__bullet-items__item'],
                          activeItem === i && styles['mobile-list__bullet-items__item--active']
                        )}
                        key={i}
                      ></div>
                    ))}
                  </div>
                </div>
              </div>
            )
          ) : (
            renderList()
          )}
        </div>

        {isMobile && isOpenedOnMobile && (
          <div className={styles['sidebar__content__footer']}>
            <MainButton
              sizeType="medium"
              visualType="white"
              style={{ width: '100%' }}
              onClick={() => setIsOpenedOnMobile(false)}
            >
              Back
            </MainButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
